import actions from './actions';
import types from './types';

const errorLogsModule = {
  state: () => ({
    errorLogs: [],
    total: 0,
    loading: false,
    error: null,
    detail: null,
    detailLoading: false,
    stats: null,
    statsLoading: false,
    resolving: false,
    deleting: false,
  }),
  mutations: {
    [types.GET_ERROR_LOGS_START]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [types.GET_ERROR_LOGS_SUCCESS]: (state, data) => {
      state.errorLogs = data.data || [];
      state.total = data.total || 0;
      state.loading = false;
    },
    [types.GET_ERROR_LOGS_FAILURE]: (state, error) => {
      state.error = error;
      state.loading = false;
    },

    [types.GET_ERROR_LOG_DETAIL_START]: (state) => {
      state.detailLoading = true;
    },
    [types.GET_ERROR_LOG_DETAIL_SUCCESS]: (state, data) => {
      state.detail = data;
      state.detailLoading = false;
    },
    [types.GET_ERROR_LOG_DETAIL_FAILURE]: (state) => {
      state.detailLoading = false;
    },

    [types.GET_ERROR_STATS_START]: (state) => {
      state.statsLoading = true;
    },
    [types.GET_ERROR_STATS_SUCCESS]: (state, data) => {
      state.stats = data;
      state.statsLoading = false;
    },
    [types.GET_ERROR_STATS_FAILURE]: (state) => {
      state.statsLoading = false;
    },

    [types.RESOLVE_ERRORS_START]: (state) => {
      state.resolving = true;
    },
    [types.RESOLVE_ERRORS_SUCCESS]: (state) => {
      state.resolving = false;
    },
    [types.RESOLVE_ERRORS_FAILURE]: (state) => {
      state.resolving = false;
    },

    [types.DELETE_ERRORS_START]: (state) => {
      state.deleting = true;
    },
    [types.DELETE_ERRORS_SUCCESS]: (state) => {
      state.deleting = false;
    },
    [types.DELETE_ERRORS_FAILURE]: (state) => {
      state.deleting = false;
    },

    [types.CLEAR_DETAIL]: (state) => {
      state.detail = null;
    },
  },
  actions,
  namespaced: true,
};

export default errorLogsModule;
